import { Input } from "antd";
import { t } from "i18next";
import React from "react";
import { ZId } from "src/types";

import * as styles from "./IdBox.module.less";

type PropsIdBox = {
  entity?: { id?: ZId; displayId?: ZId | null };
};

export const IdBox: React.FC<PropsIdBox> = (props) => {
  const { entity } = props;

  return (
    <div className={styles.idBox}>
      <Input disabled addonBefore={t("UUID")} value={entity?.id ?? "-1"} />
      <Input
        disabled
        addonBefore={t("Display ID")}
        value={entity?.displayId ?? "-1"}
      />
    </div>
  );
};
